/* eslint-disable no-unused-vars */
export enum RequestState {
  Idle = "Idle",
  Loading = "Loading",
  Success = "Success",
  Failure = "Failure"
}
